<template>
  <div class="container-fluid adp-container-fluid">
    <div class="row no-gutters adp-wrapper">
      <div class="adp-sidebar" :class="isSidebarOpened ? 'adp-sidebar__hr-open__employee-search' : 'adp-sidebar__hr-close__employee-search'">
        <employee-search v-on:close-sidebar="closeSidebar()" v-on:open-sidebar="openSidebar()">
        </employee-search>
      </div>

      <div class="adp-main adp-main--hr" :style="isSidebarOpened ? 'margin: -926px 0 0 60px' : ''">
        <router-view></router-view>
      </div>
    </div>

    <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
  </div>
</template>

<script>
import IDP from "./IDP";
import EmployeeSearch from "./EmployeeSearch";
import EmployeeSidebar from "./EmployeeSidebar";
import ReportsModal from "./modals/ReportsModal";

export default {
  name: "ManagerPage",
  data: function () {
    return {
      isSidebarOpened: false,
      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,
    };
  },
  components: {
    'idp': IDP,
    'employee-search': EmployeeSearch,
    'employee-sidebar': EmployeeSidebar,
    'reports-modal': ReportsModal,
  },
  methods: {
    closeSidebar() {
      this.isSidebarOpened = false;
    },
    openSidebar() {
      this.isSidebarOpened = true;
    },
  },
  mounted() {
    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
  }
}
</script>

<style scoped>

</style>
